import { __ } from '@wordpress/i18n';
import {VayuBlocksSelectControl, HeightControl} from '@vayu-blocks';
import { useDispatch, useSelect } from '@wordpress/data';
import { store as blockEditorStore } from '@wordpress/block-editor';
import { useEffect } from 'react';

export const VayuBlocksWidthController = ({width, onChange ,clientId}) => {

    const options = [
        { label:  __( 'Default', 'vayu-blocks' ), value: 'default' },
        { label: __( 'Full Width(100%)', 'vayu-blocks' ), value: 'fullwidth' },
        { label: __( 'Inline(Auto)', 'vayu-blocks' ), value: 'inlinewidth' },
        { label: __( 'Custom', 'vayu-blocks' ), value: 'customwidth' },
    ];

    const handleWidth = (value) => {
		const updatedWidth = {
			...width?.value,
			value: value,
		};
  
		onChange(width.key, updatedWidth);
	};

    const handleCustomWidth = (value) => {
        const updatedWidth = {
			...width?.value,
			customWidth: value,
		};

		onChange(width.key, updatedWidth);
    }

    const { updateBlockAttributes } = useDispatch(blockEditorStore);

	useEffect(() => {
		if (!clientId || !width?.value?.value) return;
		const selected = width.value.value;

		if (selected === 'fullwidth' || selected === 'customwidth') {
			updateBlockAttributes(clientId, { align: 'full' });
		} else {
			updateBlockAttributes(clientId, { align: '' });
		}
	}, [width?.value, clientId]);

  return (
    <>
        <VayuBlocksSelectControl
            label={__('Width', 'vayu-blocks')}
            value={width?.value?.value || 'default'}
            options={options}
            onChange={handleWidth}
        />

        {width?.value?.value === 'customwidth' && (
            <>
                <HeightControl
                    label={__('Custom Width', 'vayu-blocks')}
                    value={ width?.value?.customWidth }
                    onChange={ handleCustomWidth}
                    customUnits={['px','%','em']}
                    unitMax={{px:{max:1700, step:1}}}
                    responsive={true}
                />

                <br/>
            </>
        )}

    </>
  )
}


// "advWidth":{
// 	"type":"object",
// 	"default":{
// 		"value":"default",
// 		"customWidth":""
// 	}
// }